import { Subject } from 'rxjs';

export const globalNotification = new Subject<string>();
